export default {
  "blockStyleSpacing": "_0JO1V",
  "codeBlock": "vMTcR _0JO1V",
  "renderedInTable": "B---H"
};